import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViewTableComponent } from './table/view-table.component';
import { NzTableModule } from 'ng-zorro-antd/table';
import { AntModule } from '../ant/ant.module';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { ViewButtonComponent } from './button/view-button.component';
import { ViewConfirmComponent } from './confirm/view-confirm.component';
import { NzResizableModule, NzResizableService } from 'ng-zorro-antd/resizable';
import { ViewMenuComponent } from './menu/view-menu.component';
import { ViewQueryBuilderComponent } from './query-builder/view-query-builder.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ViewQuekFilterComponent } from './quek-filter/view-quek-filter.component';
import { DirectiveModule } from '../directive/directive.module';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ViewChartComponent } from './chart/view-chart.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { ViewSearchTableComponent } from './view-search-table/view-search-table.component';
import { ViewGridsterDashboardComponent } from './gridster-dashboard/view-gridster-dashboard.component';
import { GridsterModule } from 'angular-gridster2';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';

@NgModule({
  declarations: [
    ViewTableComponent,
    ViewButtonComponent,
    ViewConfirmComponent,
    ViewMenuComponent,
    ViewQueryBuilderComponent,
    ViewQuekFilterComponent,
    ViewChartComponent,
    ViewSearchTableComponent,
    ViewGridsterDashboardComponent,
  ],
  imports: [
    CommonModule,
    NzTableModule,
    AntModule,
    NzDropDownModule,
    NzResizableModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    DirectiveModule,
    NzDividerModule,
    DragDropModule,
    NgApexchartsModule,
    GridsterModule,
    NzButtonModule,
    NzIconModule,
  ],
  exports: [
    ViewTableComponent,
    ViewButtonComponent,
    ViewConfirmComponent,
    ViewMenuComponent,
    ViewQueryBuilderComponent,
    ViewQuekFilterComponent,
    ViewChartComponent,
    ViewSearchTableComponent,
    ViewGridsterDashboardComponent,
  ],
  providers: [NzResizableService],
})
export class ViewModule {}
